module.exports = __webpack_public_path__ + "img/icon-add.c96f15a3.svg";